// extracted by mini-css-extract-plugin
export default {"itemContainer":"displayitems_itemContainer__7hLjj","itemsContainer":"displayitems_itemsContainer__ygRow"};